"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _iconCross = require("./icon-cross");
var _kDsFoundation = _interopRequireDefault(require("../../lib/k-ds-foundation"));
var _excluded = ["className", "children", "type", "color"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var PRESET_COLORS = {
  'red': {
    background: 'red-100',
    text: 'red-900'
  },
  'red-outline': {
    background: 'transparent',
    text: 'red-900',
    border: 'red-900'
  },
  'blue': {
    background: 'blue-100',
    text: 'blue-700'
  },
  'blue-outline': {
    background: 'transparent',
    text: 'blue-700',
    border: 'blue-700'
  },
  'purple': {
    background: 'deep-purple-100',
    text: 'deep-purple-700'
  },
  'purple-outline': {
    background: 'transparent',
    text: 'purple-700',
    border: 'purple-700'
  },
  'teal': {
    background: 'teal-100',
    text: 'teal-700'
  },
  'teal-outline': {
    background: 'transparent',
    text: 'teal-700',
    border: 'teal-700'
  },
  'green': {
    background: 'light-green-100',
    text: 'light-green-900'
  },
  'green-outline': {
    background: 'transparent',
    text: 'light-green-900',
    border: 'light-green-900'
  },
  'cyan': {
    background: 'cyan-100',
    text: 'cyan-700'
  },
  'cyan-outline': {
    background: 'transparent',
    text: 'cyan-700',
    border: 'cyan-700'
  },
  'grey': {
    background: 'grey-300',
    text: 'grey-900'
  },
  'grey-outline': {
    background: 'transparent',
    text: 'grey-900',
    border: 'grey-900'
  },
  'orange': {
    background: 'orange-100',
    text: 'amber-900'
  },
  'orange-outline': {
    background: 'transparent',
    text: 'amber-900',
    border: 'amber-900'
  }
};
function getColors(color) {
  if (!color) return {};
  var colors = PRESET_COLORS[color];
  return colors || {};
}
var StyledTag = /*#__PURE__*/_styledComponents["default"].button.withConfig({
  componentId: "kds-v1__sc-1m14z5t-0"
})(["display:inline-flex;align-items:center;justify-content:center;", " ", " ", " ", " ", ";border-radius:8px;border:0;", " &:enabled{&:focus{", "}}&:disabled{opacity:0.5;}"], function (props) {
  return props.isDefault && (0, _styledComponents.css)(["", ""], _kDsFoundation["default"].setColorTokenWithFallback('background: ', 'background-alternate'));
}, function (props) {
  var _props$colors;
  return ((_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.background) && (0, _styledComponents.css)(["", ""], _kDsFoundation["default"].setColorWithFallback('background:', props.colors.background));
}, function (props) {
  return props.isDefault && (0, _styledComponents.css)(["", ""], _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'text-primary'));
}, function (props) {
  var _props$colors2;
  return ((_props$colors2 = props.colors) === null || _props$colors2 === void 0 ? void 0 : _props$colors2.text) && (0, _styledComponents.css)(["", ""], _kDsFoundation["default"].setColorWithFallback('color:', props.colors.text));
}, _kDsFoundation["default"].setSpacingWithFallback('padding: ', 'spacing-02', 'spacing-03'), function (props) {
  var _props$colors3;
  return ((_props$colors3 = props.colors) === null || _props$colors3 === void 0 ? void 0 : _props$colors3.border) && (0, _styledComponents.css)(["", ""], _kDsFoundation["default"].setColorWithFallback('border: 1px solid ', props.colors.border));
}, function (props) {
  return props.isDefault && (0, _styledComponents.css)(["", ""], _kDsFoundation["default"].setColorTokenWithFallback('border: 1px solid ', 'inverse-background'));
});
var Tag = exports.Tag = function Tag(_ref) {
  var className = _ref.className,
    children = _ref.children,
    type = _ref.type,
    color = _ref.color,
    moreProps = _objectWithoutProperties(_ref, _excluded);
  var tagClassName = className ? "".concat(className, " k-ds-label-01") : 'k-ds-label-01';
  var colors = getColors(color);
  var isDefault = !color || Object.keys(colors).length === 0;
  var props = _objectSpread(_objectSpread({}, moreProps), {}, {
    isDefault: isDefault
  });
  if (!isDefault) {
    props = _objectSpread(_objectSpread({}, moreProps), {}, {
      colors: colors
    });
  }
  var showCrossIcon = type === 'filtered';
  return /*#__PURE__*/_react["default"].createElement(StyledTag, _extends({
    className: tagClassName
  }, props), children, showCrossIcon ? /*#__PURE__*/_react["default"].createElement(_iconCross.IconCross, {
    className: "k-ds-m-left-sp-04"
  }) : null);
};